/**
 * Spartan Commercial — Instant Predictive Quick Search
 * Fast, debounced, accessible live search autocomplete using Shopify's native suggest API.
 */
(function () {
  'use strict';

  function getSearchUrl() {
    if (window.Theme && window.Theme.routes && window.Theme.routes.search_url) {
      return window.Theme.routes.search_url;
    }
    if (window.Theme && window.Theme.searchUrl) {
      return window.Theme.searchUrl;
    }
    return '/search';
  }

  function initPredictiveSearch() {
    var forms = document.querySelectorAll('.sp-search');
    if (!forms.length) return;

    forms.forEach(function (form) {
      if (form.dataset.spSearchBound) return;
      form.dataset.spSearchBound = 'true';

      var input = form.querySelector('input[type="search"], .sp-search-input');
      if (!input) return;

      var container = document.createElement('div');
      container.className = 'sp-predictive-dropdown';
      container.setAttribute('role', 'listbox');
      container.setAttribute('aria-label', 'Search suggestions');
      container.hidden = true;
      form.appendChild(container);

      var timer = null;
      var cache = {};
      var selectedIndex = -1;

      function closeDropdown() {
        container.hidden = true;
        container.innerHTML = '';
        selectedIndex = -1;
        input.removeAttribute('aria-activedescendant');
      }

      function updateAriaSelected(items) {
        items.forEach(function (item, idx) {
          if (idx === selectedIndex) {
            item.classList.add('is-selected');
            item.setAttribute('aria-selected', 'true');
            input.setAttribute('aria-activedescendant', item.id || ('sp-res-' + idx));
          } else {
            item.classList.remove('is-selected');
            item.setAttribute('aria-selected', 'false');
          }
        });
      }

      function renderResults(query, data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        var searchUrl = getSearchUrl();
        var quoteLabel = (window.Theme && window.Theme.quoteLabel) || 'Commercial pricing on request';

        if (!products.length) {
          container.innerHTML = '<div class="sp-ps-empty">' +
            '<p>No equipment matching <strong>' + escapeHtml(query) + '</strong></p>' +
            '<a class="sp-ps-empty-link" href="' + searchUrl + '?q=' + encodeURIComponent(query) + '">Search full catalogue &rarr;</a>' +
            '</div>';
          container.hidden = false;
          return;
        }

        var html = '<div class="sp-ps-inner">';
        html += '<div class="sp-ps-header"><span>Matching Commercial Equipment</span><span class="sp-ps-count">' + products.length + ' shown</span></div>';
        html += '<ul class="sp-ps-list" role="presentation">';

        products.forEach(function (prod, idx) {
          var itemId = 'sp-res-' + idx;
          var img = prod.image || prod.featured_image || '';
          var vendor = prod.vendor || '';
          var title = prod.title || '';
          var url = prod.url || '';
          var price = quoteLabel;

          html += '<li id="' + itemId + '" class="sp-ps-item" role="option" aria-selected="false">';
          html += '<a class="sp-ps-link" href="' + url + '">';
          if (img) {
            html += '<div class="sp-ps-img" style="background-image:url(\'' + escapeHtml(img) + '\')"></div>';
          } else {
            html += '<div class="sp-ps-img sp-ps-img--placeholder"><span>No photo</span></div>';
          }
          html += '<div class="sp-ps-info">';
          if (vendor) {
            html += '<span class="sp-ps-vendor">' + escapeHtml(vendor) + '</span>';
          }
          html += '<h5 class="sp-ps-title">' + escapeHtml(title) + '</h5>';
          html += '<span class="sp-ps-price">' + escapeHtml(price) + '</span>';
          html += '</div>';
          html += '<span class="sp-ps-action">View &rarr;</span>';
          html += '</a></li>';
        });

        html += '</ul>';
        html += '<div class="sp-ps-footer">';
        html += '<a class="sp-ps-all-btn" href="' + searchUrl + '?q=' + encodeURIComponent(query) + '"><span>View all results for &ldquo;' + escapeHtml(query) + '&rdquo;</span> &rarr;</a>';
        html += '</div>';
        html += '</div>';

        container.innerHTML = html;
        container.hidden = false;
        selectedIndex = -1;
      }

      function fetchSuggestions(query) {
        var cleanQ = query.trim();
        if (cleanQ.length < 2) {
          closeDropdown();
          return;
        }

        if (cache[cleanQ]) {
          renderResults(cleanQ, cache[cleanQ]);
          return;
        }

        container.innerHTML = '<div class="sp-ps-loading"><span class="sp-ps-spinner"></span> Searching...</div>';
        container.hidden = false;

        var url = '/search/suggest.json?q=' + encodeURIComponent(cleanQ) + '&resources[type]=product&resources[limit]=6';
        fetch(url)
          .then(function (res) {
            if (!res.ok) throw new Error('Search response error');
            return res.json();
          })
          .then(function (data) {
            cache[cleanQ] = data;
            if (input.value.trim() === cleanQ) {
              renderResults(cleanQ, data);
            }
          })
          .catch(function () {
            closeDropdown();
          });
      }

      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = this.value;
        if (!q || q.trim().length < 2) {
          closeDropdown();
          return;
        }
        timer = setTimeout(function () {
          fetchSuggestions(q);
        }, 220);
      });

      input.addEventListener('keydown', function (e) {
        if (container.hidden) return;
        var items = container.querySelectorAll('.sp-ps-item');
        if (!items.length) return;

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          selectedIndex = (selectedIndex + 1) % items.length;
          updateAriaSelected(items);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          selectedIndex = (selectedIndex - 1 + items.length) % items.length;
          updateAriaSelected(items);
        } else if (e.key === 'Enter' && selectedIndex >= 0) {
          var activeLink = items[selectedIndex].querySelector('a');
          if (activeLink) {
            e.preventDefault();
            activeLink.click();
          }
        } else if (e.key === 'Escape') {
          closeDropdown();
        }
      });

      document.addEventListener('click', function (e) {
        if (!form.contains(e.target)) {
          closeDropdown();
        }
      });
    });
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  window.Theme = window.Theme || {};
  window.Theme.searchUrl = getSearchUrl();
  window.Theme.quoteLabel = window.Theme.quoteLabel || 'Commercial pricing on request';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPredictiveSearch);
  } else {
    initPredictiveSearch();
  }
})();
